import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from "@angular/core";
import { StakingAmountUIModel } from "@modules/staking/domain/entities/staking-amount-selector-state.model";
import { StakingActionType } from "@modules/staking/domain/entities/staking-process.model";
import { EMPTY, Observable, of } from "rxjs";
import { concatMap, tap } from "rxjs/operators";
import { StakingAmountSelectorFacade } from "./+state/staking-amount-selector.facade";
import { findIndexInAmountModelOptions } from "./+state/utils/staking-amount-selector.util";
import { EarnConsentScreenFacade } from "@modules/staking/components/earn-consent-screen/earn-consent.screen.facade";
import { Stakeable } from "@modules/staking/domain/entities/stakeable.model";
import { Router } from "@angular/router";
import { StakingMode } from "@gql/staking";
import { ROUTER_OUTLET_NAME } from "@modules/+new/shared/universal-modal/entities/magic";
import { EarnRoutes } from "@modules/staking/components/earn-consent-screen/earn-consent-screen.module";

@Component({
	selector: "app-stake-amount-selector",
	templateUrl: "./amount-selector.component.html",
	styleUrls: ["./amount-selector.component.scss"],
	providers: [StakingAmountSelectorFacade],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class AmountSelectorComponent implements OnInit {
	@Input() stakeable: Stakeable;
	@Input() seenEarnTerms: boolean = false;
	public hasMultipleWallets: boolean = false;
	public stakingAmountUIModel$: Observable<StakingAmountUIModel> = EMPTY;
	public stakingTypes = StakingActionType;
	public manualPercentSelected: boolean = false;
	private readonly earnConsentFacade = inject(EarnConsentScreenFacade);
	private readonly router = inject(Router);

	constructor(private amountFacade: StakingAmountSelectorFacade) {}

	public ngOnInit(): void {
		if (!this.seenEarnTerms && !!this.stakeable) {
			if (this.stakeable.stakingMode === StakingMode.Earn) {
				this.earnConsentFacade.setViewModel(this.stakeable.id);
				this.router.navigate(
					[{ outlets: { [ROUTER_OUTLET_NAME]: [EarnRoutes.basePath, EarnRoutes.consent] } }],
					{
						queryParams: { fromADP: true }
					}
				);
				return;
			}
		}
		this.stakingAmountUIModel$ = this.amountFacade.getStakingAmountSelectorState$().pipe(
			concatMap((model: StakingAmountUIModel, index: number) =>
				index === 0 && +model.value === 0
					? of(model).pipe(
							tap((model: StakingAmountUIModel) => {
								this.hasMultipleWallets = model.hasMultipleWallets;
								this.setPercentage(model.selectedPercentage, model);
							})
						)
					: index === 0
						? of(model).pipe(
								tap((model: StakingAmountUIModel) => {
									this.setPercentage(findIndexInAmountModelOptions(model.value, model), model);
								})
							)
						: of(model)
			)
		);
	}

	public triggerExchange(state: StakingAmountUIModel): void {
		this.amountFacade.triggerExchange(state);
	}

	public setPercentage(index: number, state: StakingAmountUIModel, manualClick?: boolean): void {
		if (manualClick) {
			this.manualPercentSelected = true;
			this.amountFacade.setPercentage(index, state);
		}
	}

	public valueChange(newValue: string, state: StakingAmountUIModel): void {
		this.amountFacade.updateValue(newValue, state);
	}
}
